import { render } from "./video-outline.vue?vue&type=template&id=732e1670&scoped=true"
import script from "./video-outline.vue?vue&type=script&lang=js"
export * from "./video-outline.vue?vue&type=script&lang=js"

import "./video-outline.vue?vue&type=style&index=0&id=732e1670&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732e1670"]])

export default __exports__